<div class="editor-header">
    <div class="header-container header-left">
        <div class="logo-container">
            <a (click)="toggleSidebar('primary')" href="#" class="sidebar-toggle">
              <nb-icon [icon]="isPrimaryCollapsed?'eye-outline':'eye-off-outline'" pack="eva"></nb-icon>
            </a>
            <a class="logo" href="#" (click)="navigateHome()">
                <!-- <img src="http://kwikstore-dev/assets/ksIcon_40.svg" height="40"/> -->
                <img src="http://kwikstore-dev/assets/latest_logo_on_dark.png" height="40"/>
            </a>
          </div>
    </div>
    <div class="header-container header-center">
        SITE/{{selectedSite?.siteName??"No Site Selected"}}/PAGE/{{selectedPageType}}
    </div>
    <div class="header-container header-right">
        <nb-actions size="tiny">
            <nb-action class="custom-action" link="#"(click)="navigateLink($event)" title="Kwikhub">Hub</nb-action>
            <nb-action class="custom-action" link="admin/pms"(click)="navigateLink($event)" title="Product Management System">Product Management</nb-action>
            <nb-action class="custom-action" link="admin/cms"(click)="navigateLink($event)" title="Content Management System">Content Management</nb-action>
            <nb-action title="Snapshot" (click)="snapShot($event)">
                <nb-icon class="toggle-icon" icon="camera-outline" pack="eva">Photo</nb-icon>
            </nb-action>
            <nb-action title="Intro">
                <nb-icon icon="play-circle-outline" pack="eva" (click)="playIntro()"></nb-icon>
            </nb-action>
            <nb-action title="Site Picker"
            [nbPopover]="sitePickerPop" 
            [nbPopoverContext]="{color:'#fff'}" nbPopoverPlacement="bottom">
                <nb-icon icon="browser-outline" pack="eva"></nb-icon>
            </nb-action>
        </nb-actions>
        <a (click)="toggleSidebar('right')" href="#" class="sidebar-toggle">
            <nb-icon [icon]="isSecondaryCollapsed?'eye-outline':'eye-off-outline'" pack="eva"></nb-icon>
          </a>
        <!-- Editor Navigation Here -->
    </div>
</div>
